// extracted by mini-css-extract-plugin
module.exports = {"landing_page_A":"A_landing_page_A__cIS5a"};